import { AlterPasswordPage } from "./pages/AlterPasswordPage/AlterPasswordPage";
import { DocumentListPage } from "./pages/DocumentListPage/DocumentListPage";
import { EditUserResourcePage } from "./pages/EditUserResourcePage/EditUserResourcePage";
import { InstrumentationPage } from "./pages/InstrumentationPage/InstrumentationPage";
import { PointCloudPage } from "./pages/PointCloudPage/PointCloudPage";
import { NewUserPage } from './pages/NewUserPage/NewUserPage';
import { NewUserResourcePage } from "./pages/NewUserResourcePage/NewUserResourcePage";
import { UploadDocumentPage } from "./pages/UploadDocumentPage/UploadDocumentPage";
import { UserListPage } from './pages/UserListPage/UserListPage';
import { UserProfilePage } from './pages/UserProfilePage/UserProfilePage';
import { WebGisPage } from "./pages/WebGisPage/WebGisPage";

const pageList = [
  {
    name: 'Alteração de Senha',
    path: '/dashboard/alter-password/:id/',
    component: AlterPasswordPage,
    componentName: 'AlterPasswordPage'
  },
  {
    name: 'Listagem de Arquivos',
    path: '/dashboard/documents',
    component: DocumentListPage,
    componentName: 'DocumentListPage'
  },
  {
    name: 'Edição de Recurso de Usuário',
    path: '/dashboard/user/:userId/resources/:resourceId/',
    component: EditUserResourcePage,
    componentName: 'EditUserResourcePage'
  },
  {
    name: 'Instrumentação',
    path: '/dashboard/instrumentation',
    component: InstrumentationPage,
    componentName: 'InstrumentationPage'
  },
  {
    name: 'Nuvem de Pontos',
    path: '/dashboard/point-cloud',
    component: PointCloudPage,
    componentName: 'PointCloudPage'
  },
  {
    name: 'Novo Usuário',
    path: '/dashboard/users/new',
    component: NewUserPage,
    componentName: 'NewUserPage'
  },
  {
    name: 'Novo Recurso de Usuário',
    path: '/dashboard/user/:userId/resource',
    component: NewUserResourcePage,
    componentName: 'NewUserResourcePage'
  },
  {
    name: 'Importar Arquivos',
    path: '/dashboard/upload-documents',
    component: UploadDocumentPage,
    componentName: 'UploadDocumentPage'
  },
  {
    name: 'Perfil de Usuário',
    path: '/dashboard/users/:id/profile/',
    component: UserProfilePage,
    componentName: 'UserProfilePage'
  },
  {
    name: 'Listagem de Usuários',
    path: '/dashboard/users',
    component: UserListPage,
    componentName: 'UserListPage'
  },
  {
    name: 'WebGis',
    path: '/dashboard/web-gis',
    component: WebGisPage,
    componentName: 'WebGisPage'
  }
];

export default pageList;
